import { useEffect, useState } from "react";
import { parentGetSupervisorNotes } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import ParentEmpty from "./ParentEmpty";
import ParentFmt from "./ParentFmt";
import { useAuth } from "context/AuthContext";

const ParentNotesTab = ({ studentId }) => {
    const { userInfo } = useAuth();
    const [data, setData] = useState(null);

    useEffect(() => {

        parentGetSupervisorNotes(userInfo?.token, Number(studentId)).then(r => setData(r.notes)).catch(() => setData([]));

    }, [studentId]);



    if (!data) return <ParentLoader />;

    if (data.length === 0) return <ParentEmpty msg="لا توجد ملاحظات من المشرفين" />;



    return (

        <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl overflow-hidden shadow-sm">

            <div className="overflow-x-auto">

                <table className="w-full text-base text-right">

                    <thead className="bg-gray-100/80 dark:bg-white/10 text-gray-900 dark:text-gray-100 font-bold border-b border-gray-300 dark:border-white/20">

                        <tr>

                            <th className="px-6 py-4">المشرف</th>

                            <th className="px-6 py-4">النوع</th>

                            <th className="px-6 py-4">الملاحظة للطالب</th>

                            <th className="px-6 py-4">التاريخ</th>

                        </tr>

                    </thead>

                    <tbody className="divide-y divide-gray-200 dark:divide-white/5">

                        {data.map(n => {

                            const emp = n.employee;

                            const name = emp ? `${emp.first_name} ${emp.middle_name || ''} ${emp.last_name}`.trim() : '—';

                            const isPositive = n.type === 'ايجابي';



                            return (

                                <tr key={n.id} className="hover:bg-gray-50/50 dark:hover:bg-white/5 transition-colors">

                                    <td className="px-6 py-4 text-gray-900 dark:text-gray-100 font-bold whitespace-nowrap">{name}</td>

                                    <td className="px-6 py-4 whitespace-nowrap">

                                        <span className={`px-3 py-1 rounded-full text-sm font-bold border shadow-sm ${isPositive ? 'bg-emerald-100 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-300 border-emerald-300 dark:border-emerald-500/50' : 'bg-red-100 dark:bg-red-500/20 text-red-700 dark:text-red-300 border-red-300 dark:border-red-500/50'}`}>

                                            {n.type}

                                        </span>

                                    </td>

                                    <td className="px-6 py-4 text-gray-800 dark:text-gray-300 font-medium min-w-[200px]">{n.comment}</td>

                                    <td className="px-6 py-4 text-gray-700 dark:text-gray-400 whitespace-nowrap font-medium">{ParentFmt(n.date)}</td>

                                </tr>

                            );

                        })}

                    </tbody>

                </table>

            </div>

        </div>

    );
}

export default ParentNotesTab;